export default {
  campaigns(state) {
    if (state.lists.lenght <= 0) {
      state.lists = JSON.parse(localStorage.getItem("campaigns")) || [];
    }
    return JSON.parse(localStorage.getItem("campaigns")) || [];
  },
};
